import React from 'react';

const TableRowDelete = ({
    onClick = () => {}
}) =>(
    <span onClick={onClick} className="m-2 font-danger" style={{cursor: 'pointer'}}>
        <i className="fa fa-trash-o"></i>
    </span>
);

export default TableRowDelete;